<template>
  <div class="login-page">
    <div class="wrapper wrapper-full-page">
      <div class="full-page login-page section-image">
        <!--   you can change the color of the filter page using: data-color="blue | azure | green | orange | red | purple" -->
        <div class="content">
          <div class="container">
              <div class="col-lg-4 col-md-6 ml-auto mr-auto">
                <card type="login">
                  <h3 slot="header" class="header text-center">Login</h3>

                  <fg-input v-model.trim="email" addon-left-icon="nc-icon nc-single-02"  placeholder="Email or Username" autofocus></fg-input>

                  <fg-input v-model="password" addon-left-icon="nc-icon nc-key-25" placeholder="Password" type="password" @keyup.enter="onLogin"></fg-input>

                  <br>

                  <p-button slot="footer" type="info" round block class="mb-3" @click="onLogin" :disabled="loading">
                    <i class="fa fa-spinner fa-spin" v-show="loading"></i>
                    <span v-show="!loading">Login</span>
                  </p-button>
                </card>
              </div>
          </div>
        </div>
        <!-- <app-footer></app-footer> -->
        <div class="full-page-background" style="background-image: url(static/img/background/background-3.jpeg) "></div>
      </div>
    </div>
  </div>
</template>
<script>
// import {mapGetters} from 'vuex'
import {Card, Checkbox, Button} from 'src/components/UIComponents';
import AppNavbar from './Layout/AppNavbar'
import AppFooter from './Layout/AppFooter'
import * as _apiAuth from "@/api/auth"
import axios from 'axios'
import { JWTDecode } from '@/utils/common'

export default {
  components: {
    Card,
    AppNavbar,
    AppFooter,
    [Checkbox.name]: Checkbox,
    [Button.name]: Button
  },
  data() {
    return {
      email: '',
      password: '',
      loading: false,
      error: {
        isError: false,
        msg:"",
      }
    }
  },
  computed: {
    // ...mapGetters({
    //   currentUser: "$_user/currentUser"
    // }),
    // nextRoute () {
    //   return this.$route.query.redirect || '/'
    // }
  },
  watch: {
    // currentUser (auth) {
    //   if(!!auth){
    //     this.$router.replace(this.nextRoute)
    //   }
    // }
  },
  methods: {
    JWTDecode: JWTDecode,
    toggleNavbar () {
      document.body.classList.toggle('nav-open')
    },
    closeMenu () {
      document.body.classList.remove('nav-open')
      document.body.classList.remove('off-canvas-sidebar')
    },
    async onLogin () {
      this.loading = true
      try {
        const res = await _apiAuth.login(this.email.replace(/ /g,''), this.password.replace(/ /g,''))
        let token = res.data.token
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`

        // TODO: Refactor
        var baseURL = process.env.VUE_APP_ROOT_API || 'http://127.0.0.1:5005'
        const user = this.JWTDecode(token)

        if (user.role === 'user') {
          baseURL = baseURL + '/api/w'
        } else if (user.role === 'customer') {
          baseURL = baseURL + '/api/c'
        }
        axios.defaults.baseURL = baseURL

        // const userData = this.JWTDecode(res.data.token)
        // localStorage.setItem('token', res.data.token)
        this.$store.dispatch("$_user/ON_AUTH_STATE_CHANGEL", token);

        this.$router.push(`/overview`)
      } catch (error) {
        this.$notify({
          message: 'email/username or password is incorrect',
          type: 'danger'
        })
      }
      finally {
          this.loading = false
          this.password = ''
      }
    }
  },
  beforeDestroy () {
    this.loading = false
    this.closeMenu()
  }
}
</script>
<style>
</style>
